import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ReportDetailsSection from "./components/ReportDetailsSection";
import PricingSection from "./components/PricingSection";
import WhyChooseSection from "./components/WhyChooseSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

const LoveReport = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <ReportDetailsSection />
        <PricingSection />
        
        <FAQSection />
      </main>
    </div>
  );
};

export default LoveReport;